<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label fw-bold">Chăm sóc học viên</h3>
      </div>

      <div v-if="currentUser.user.permission.includes(permission.EXPORT_TICKET)">
        <button class="btn btn-success font-weight-bold mt-5" @click="exportExcel"
          :class="{ 'spinner spinner-white spinner-right': is_export }">
          <i class="la la-file-excel"></i>Xuất excel
        </button>
        <button class="btn btn-success font-weight-bold mt-5 ml-2" @click="exportExcelV2"
                :class="{ 'spinner spinner-white spinner-right': is_export }">
          <i class="la la-file-excel"></i>Xuất excel v2
        </button>
        <button class="btn btn-success font-weight-bold mt-5 ml-2" @click="showSurveyExportDialog = true" :class="{ 'spinner spinner-white spinner-right': is_export_survey }">
          <i class="la la-file-excel"></i>Export khảo sát
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Mã ticket</label>
            <el-input placeholder="Mã ticket" v-model="query.ticket_id"></el-input>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Danh mục</label>
            <el-select @input="checkShowReason" v-model="query.category" filterable class="w-100" placeholder="Danh mục"
              clearable>
              <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Khách hàng</label>
            <el-input placeholder="Nhập tên, mã, số điện thoại" v-model="query.keyword"></el-input>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Trạng thái</label>
            <el-select v-model="query.status" filterable class="w-100" placeholder="Trạng thái" clearable multiple
              collapse-tags>
              <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Người phụ trách</label>
            <el-select v-model="query.person_ids" filterable class="w-100" placeholder="Chọn người phụ trách" clearable multiple
                       collapse-tags>
              <el-option v-for="item in qlhvAssignees" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <div class="form-group w-100">
              <label>Trạng thái bình luận</label>
              <el-select v-model="query.status_feedback" filterable class="w-100" placeholder="Chọn trạng thái bình luận" clearable>
                <el-option label="Chưa bình luận" :value="0"> </el-option>
                <el-option label="Có bình luận mới" :value="1"> </el-option>
                <el-option label="Đã bình luận" :value="2"> </el-option>
              </el-select>
            </div>
          </div>
        </div>  
        <div class="col-md-3">
          <div class="form-group">
            <label>Thời gian tạo</label>
            <date-picker placeholder="Thời gian tạo" range v-model="query.created_at" format="DD-MM-YYYY"
              valueType="YYYY-MM-DD"></date-picker>
          </div>
        </div>
        <div class="col-md-2 mt-8">
          <div class="d-flex justify-content-between">
            <button type="button" class="btn btn-primary font-weight-bold mr-2" :disabled="is_disable_search"
              :class="{ 'spinner spinner-white spinner-left': is_disable_search }" @click="search">
              Tìm kiếm
            </button>
          </div>
        </div>
      </div>

      <div class="example mb-10">
        <div class="example-preview table-responsive ">
          <div v-if="selectedItems.length > 0" class="d-flex align-items-center m-3">
            <span class="mr-3">Đã chọn ({{ selectedItems.length }})</span>
            <button class="btn btn-primary mr-2" @click="openAssignDialog"><i class="fa fa-random mr-1"></i> Điều phối
              công việc</button>
            <button class="btn btn-light" @click="() => { selectedItems = []; selectAll = false; }">Hủy</button>
          </div>
          <table class="table table-vertical-center">
            <thead class="table-secondary">
              <tr>
                <th style="width: 50px;" class="text-center">
                  <el-checkbox v-model="selectAll" @change="handleSelectAll"></el-checkbox>
                </th>
                <th class="min-w-50px" scope="col">Mã ticket</th>
                <th scope="col" class="min-w-150px">Danh mục</th>
                <th scope="col" class="min-w-100px">Lớp học</th>
                <th scope="col" class="min-w-120px">Khách hàng</th>
                <th scope="col" class="min-w-120px">Phòng ban Xử lý</th>
                <th scope="col" class="min-w-120px">Trạng thái</th>
                <th scope="col" class="min-w-150px">Trạng thái bình luận</th>
                <th scope="col" class="min-w-150px">Người phụ trách</th>
                <th scope="col" class="min-w-150px">Thời gian tạo</th>
                <th scope="col" class="min-w-80px">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tickets.data" :key="index">
                <td>
                  <el-checkbox class="ml-2" v-model="selectedItems" :label="item.id"
                               :disabled="item.status == 3 || item.status == 0"><span></span></el-checkbox>
                </td>
                <td>{{ item.id }}</td>
                <td>
                  <span>{{ changeCategoryName(item.category_chamsoc) }}</span>
                </td>
                <td>{{ item.classes ? item.classes.name : '' }}</td>
                <td>{{ item.student_edutalk ? item.student_edutalk.name + ' - ' + item.student_edutalk.phone : '' }}</td>
                <td>{{ phong_ban_xu_ly_define[item.phong_ban_xu_ly] ? phong_ban_xu_ly_define[item.phong_ban_xu_ly] : 'TTHT' }}</td>
                <td><span :class="statusDefineCss[item.status]">{{ statusDefine[item.status] }}</span></td>
                <td>
                  <span :class="statusFeedback[item.status_comment]">{{ statusFeedbackDefine[item.status_comment] }}</span>
                </td>
                <td>{{ item.person_in_charge ? item.person_in_charge.name : '' }}</td>
                <td>{{ item.created_at | formatDateTime }}</td>
                <td>
                  <router-link :to="{ name: 'ticket-show', params: { id: item.id } }" title="Xem"
                    v-if="currentUser.user.permission.includes(permission.XEM_CHI_TIET_TICKET)"
                    class="btn btn-sm btn-icon  btn-outline-info"><i class="fas far fa-eye"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="position-absolute" style="right:40px">
              Tổng số bản ghi: <b style="color:#3699FF">{{ this.tickets.total }}</b>
        </div>
      </div>
    </div>
    <div class="edu-paginate mx-auto text-center">
      <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1" :click-handler="clickCallback"
        :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'" :pageLinkClass="'page-link'"
        :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'" :prev-class="'page-link'"
        :next-class="'page-link'" :page-class="'page-item'">
      </paginate>
    </div>
    <!-- Assign Modal -->
    <assign-dialog v-if="assignDialogVisible" :visible.sync="assignDialogVisible" :qc-assignees="qlhvAssignees"
                   :selected-ids="selectedItems" @confirm="onAssignConfirm" />

    <!-- Survey Export Dialog -->
    <el-dialog title="Vui lòng chọn dữ liệu để tải xuống" :visible.sync="showSurveyExportDialog" width="500px" :close-on-click-modal="false">
      <div class="d-flex flex-column">
        <el-checkbox-group v-model="surveyExportTypes" class="d-flex flex-column">
          <el-checkbox label="satisfaction" class="mb-3">Khảo sát tỉ lệ hài lòng</el-checkbox>
          <el-checkbox label="brand">Khảo sát thương hiệu</el-checkbox>
            <el-checkbox label="new">Khảo sát điểm chạm khách hàng mới</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSurveyExportDialog">Đóng</el-button>
        <el-button type="primary" :disabled="!surveyExportTypes.length" :loading="is_export_survey" @click="handleSurveyExport">Export</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
    CATEGORY,
    EXPORT_BRAND_SURVEY,
    EXPORT_CONTRACT_SURVEY,
    EXPORT_EXCEL_SURVEY,
    EXPORT_EXCEL_TICKET,
    EXPORT_EXCEL_TICKET_V2,
    GET_ALL_TICKET,
    GET_OBJECT_FEEDBACK,
    GET_SOURCE,
    GET_TICKET_REASON_BY_TYPE,
    REASON_ERROR
} from "@/core/services/store/user/ticket.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {GET_CENTERS} from "@/core/services/store/center/centers.module";
import {GET_BRANCHES} from "@/core/services/store/center/branch.module";
import {GET_COURSES} from "@/core/services/store/course/course.module";
import {GET_CLASSES} from "@/core/services/store/course/classes.module";
import {mapGetters} from "vuex";
import {exportExcel} from "@/core/filters";
import writeXlsxFile from "write-excel-file";
import ModalCreateTicket from "../crm/tickets/components/ModalCreateTicket";
import {GET_DEPARTMENT} from "@/core/services/store/user/department.module";
import AssignDialog from "../quality-management/components/inspection-management/AssignDialog";
import {GET_USER_QLHV} from "@/core/services/store/user/users.module";
import {ASSIGNEES_TICKET} from "@/core/services/store/ticket/ticket.module";
import {HOC_VIDEO_BUOI_NGHI} from "@/core/option/ticket";

export default {
  name: "TicketIndex",
  components: {
    DatePicker,
    ModalCreateTicket, AssignDialog
  },
  data() {
    return {
      selectedItems: [],
      page: 1,
      last_page: 1,
      is_disable_search: false,
      is_export: false,
      is_export_survey: false,
      is_show_reason: false,
      is_show_reasons: false,
      tickets: [],
      listReason: '',
      query: {
        keyword: '',
        ticket_id: '',
        category: '',
        status: [],
        created_at: '',
        is_auto: [1],
        category_chamsoc: [1, 6, 11, 24, HOC_VIDEO_BUOI_NGHI],
        reason_id: '',
        person_ids: '',
      },
      categories: [
        {
          id: 1,
          name: "Nghỉ học"
        },
        {
          id: 6,
          name: "Feedback thấp"
        },
        // {
        //   id: 10,
        //   name: "Kết quả BTVN không tốt"
        // },
        {
          id: 11,
          name: "Không làm BTVN"
        },
        {
          id: 24,
          name: "Chăm sóc học viên thi giữa khóa"
        },
        {
          id: HOC_VIDEO_BUOI_NGHI,
          name: "Học video buổi nghỉ"
        },
      ],
      branches: [],
      centers: [],
      courses: [],
      classes: [],
      status: [
        {
          id: 1,
          name: "Chờ xử lý"
        },
        {
          id: 2,
          name: "Đã nhập giải pháp"
        },
        {
          id: 3,
          name: "Đã hoàn thành"
        },
        {
          id: 0,
          name: "Huỷ"
        }
      ],
      phong_ban_xu_ly_define: {
        1: 'TTHT',
        2: 'Tài chính',
        3: 'Nhân sự',
        4: 'SPNN',
        5: 'CNTT',
        6: 'Đối tác',
        7: 'STVT',
        8: 'Đào tạo',
        9: 'Brand',
        10: 'Digital',
        11: 'Marketing',
        12: 'R&D',
        13: 'Pháp lý',
        14: 'QLHV',
        15: 'CSVC',
        31: 'QLHV Online',
      },
      statusFeedbackDefine: {
        0: "Chưa bình luận",
        1: "Có bình luận mới",
        2: "Đã bình luận",
      },
      statusFeedback: {
        0: "badge badge-info",
        1: "badge badge-danger",
        2: "badge badge-success",
      },
      statusDefine: {
        0: "Huỷ",
        1: "Chờ xử lý",
        2: "Đã nhập giải pháp",
        3: "Hoàn thành",
      },
      statusDefineCss: {
        0: "badge badge-danger",
        1: "badge badge-warning",
        2: "badge badge-primary",
        3: "badge badge-success",
      },
      show: {
        lesson_leave: false,
        feedback_star: false,
        feedback_comment: false,
        exam_type: false,
        exam_total_score: false
      },
      showFilter: {
        star: false,
        exam: false
      },
      reasons: [],
      text_reason: '',
      config: {
        showMode: 'full',
        top: 60,
        right: 200,
        arrowLeft: 155,
        arrowDisplay: 'top',
        fromNumbers: [
          { alias: 'Number-1', number: '+84899199586' },
          { alias: 'Number-2', number: '+2222' }
        ],
        askCallTypeWhenMakeCall: false,
        appendToElement: null,
        makeAndReceiveCallInNewPopupWindow: false
      },
      accessToken: '',
      numbers: '',
      fromNumber: '',
      toNumber: '',
      callType: '',
      userByPhone: {},
      dialogCreateTicket: false,
      dialogAssignTicket: false,
      formTicket: {
        ticket_id: '',
      },
      fileList: [],
      sources: [],
      departments: [],
      objectFeedback: [],
      callStringeeId: '',
      checkIncoming: false,
      checkChangeIcon: false,
      messageError: '',
      reasonError: REASON_ERROR,
      loadingAssignee: false,
      dataFindTicket: {},
      search_loading: false,
      category: CATEGORY,
      category_chamsoc_define: {
        1: 'Nghỉ học 2 buổi',
        2: 'Điểm kiểm tra thấp',
        3: 'Không làm bài',
        4: 'Chua đóng tiền học',
        5: 'Đã đóng tiền học',
        6: 'Feedback thấp',
        7: 'Nghỉ học 1 buổi',
        8: 'Nghỉ học 1 buổi',
        9: 'Hướng dẫn app cho phụ huynh',
        10: 'Kết quả BTVN không tốt',
        11: 'Không làm BTVN',
        [HOC_VIDEO_BUOI_NGHI]: 'Học video buổi nghỉ'
      },
      selectAll: false,
      assignDialogVisible: false,
      qlhvAssignees: [],
      showSurveyExportDialog: false,
      surveyExportTypes: []
    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản lý ticket", route: 'ticket-index' },
      { title: "Chăm sóc học viên" }
    ]);
    // this.initStringeeSoftPhone();
    // this.connectStringeeSoftPhone();

  },
  mounted() {
    if ($("div").hasClass('hide')) {
      document.getElementById("buttonCall").classList.add('show');
      document.getElementById("buttonCall").classList.remove('hide');
    }
    this.pullParamsUrl();
    this.getCenters();
    this.getBranches();
    this.getList();
    this.getCourse();
    this.getClasses();
    this.getReasonByTicketId();
    this.showReason();
    this.getObjectFeedback();
    this.getSource();
    this.getDepartments();
    this.getDataQlhv();
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    pullParamsUrl() {
      this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
      this.query.ticket_id = this.$route.query.ticket_id ? parseInt(this.$route.query.ticket_id) : ''
      this.query.keyword = this.$route.query.keyword
      this.query.category = this.$route.query.category ? parseInt(this.$route.query.category) : ''
      this.query.status = this.$route.query.status ? [parseInt(this.$route.query.status)] : ''
      this.query.exam = this.$route.query.exam ? parseInt(this.$route.query.exam) : ''
      this.query.feedback_stars = this.$route.query.feedback_stars ? [parseInt(this.$route.query.feedback_stars)] : ''
      this.query.center_ids = this.$route.query.center_ids ? [parseInt(this.$route.query.center_ids)] : ''
      this.query.branch_ids = this.$route.query.branch_ids ? [parseInt(this.$route.query.branch_ids)] : ''
      this.query.course_ids = this.$route.query.course_ids ? [parseInt(this.$route.query.course_ids)] : ''
      this.query.class_ids = this.$route.query.class_ids ? [parseInt(this.$route.query.class_ids)] : ''
      this.query.created_at = this.$route.query.created_at ? this.$route.query.created_at : []
      this.query.reason_id = this.$route.query.reason_id ? parseInt(this.$route.query.reason_id) : ''
    },
    handleCenter() {
      this.branches = [];
      this.courses = [];
      this.query.branch_ids = [];
      this.query.branch_ids = [];

      this.getCourse();
      this.getBranches();
    },
    handleCourse() {
      this.query.class_ids = [];
      this.classes = [];
      this.getClasses();
    },
    async handleCategory() {
      this.query.reason_id = '';
      await this.resetShow();
      this.getReasonByTicketId();
      this.showFilter.star = false;
      this.showFilter.exam = false;
    },
    getReasonByTicketId() {
      switch (this.query.category) {
        case 1:
          this.is_show_reasons = true;
          this.getListReason();
          this.text_reason = 'nghỉ';
          break;
        case 6:
          this.is_show_reasons = true;
          this.getListReason();
          this.text_reason = 'feedback';
          break;
        default:
          this.is_show_reasons = false;
      }
    },
    checkShowReason() {
      this.query.reason_id = '';
      this.showReason();
    },
    showReason() {
      switch (this.query.category) {
        case 1:
          this.is_show_reason = true;
          this.getListReason();
          this.text_reason = 'nghỉ';
          break;
        case 6:
          this.is_show_reason = true;
          this.getListReason();
          this.text_reason = 'feedback';
          break;
        default:
          this.is_show_reason = false;
      }
    },
    getListReason() {
      let category = this.query.category;
      this.$store.dispatch(GET_TICKET_REASON_BY_TYPE, category).then((data) => {
        if (!data.error) {
          this.reasons = data.data;
        }
      })
    },
    checkShowColumn() {
      switch (this.query.category) {
        //Nghỉ học 2 buổi
        case 1:
          this.show.lesson_leave = true;
          break;
        //Điểm kiểm tra thấp
        case 2:
          this.showFilter.exam = true;
          this.show.exam_type = true;
          this.show.exam_total_score = true;
          break;
        //Feedback thấp
        case 6:
          this.showFilter.star = true;
          this.show.feedback_star = true;
          this.show.feedback_comment = true;
          break;
      }
    },

    resetShow() {
      this.show.lesson_leave = false;
      this.show.exam_type = false;
      this.show.exam_total_score = false;
      this.show.feedback_star = false;
      this.show.feedback_comment = false;
    },
    getCenters() {
      this.$store.dispatch(GET_CENTERS, {
        status: 1,
        limit: 100000
      }).then((data) => {
        if (!data.error) {
          this.centers = data.data.data;
        }
      })
    },
    getBranches() {
      this.$store.dispatch(GET_BRANCHES, {
        status: 1,
        limit: 100000,
        center_ids: this.query.center_ids
      }).then((data) => {
        if (!data.error) {
          this.branches = data.data.data;
        }
      })
    },

    getCourse() {
      this.$store.dispatch(GET_COURSES, {
        status: 1,
        per_page: 100000,
        only_filter: 1,
        center_ids: this.query.center_ids
      }).then((data) => {
        if (!data.error) {
          this.courses = data.data.data;
        }
      })
    },
    getClasses() {
      this.$store.dispatch(GET_CLASSES, {
        status: 1,
        limit: 100000,
        course_id: this.query.course_ids
      }).then((data) => {
        if (!data.error) {
          this.classes = data.data.data;
        }
      })
    },
    clickCallback(obj) {
      this.page = obj;
      this.pushParamsUrl();
      this.getList()
    },
    getList() {
      this.is_disable_search = true;
      this.$store.dispatch(GET_ALL_TICKET,
        {
          page: this.page,
          ...this.query
        }).then((data) => {
          this.tickets = data.data;
          this.last_page = data.data.last_page;
          this.is_disable_search = false;
          this.checkShowColumn();
        }).catch((error) => {
          console.log(error);
        })
    },
    search() {
      this.page = 1;
      this.pushParamsUrl();
      this.getList();
      this.handleCategory();
    },
    pushParamsUrl() {
      this.$router.push({
        path: '', query: {
          page: this.page,
          ...this.query
        }
      })
    },
    exportExcel() {
      this.is_export = true;
      let HEADER_ROW_EXPORT_TICKETS_CSHV = [
        {
          key: 'stt',
          value: 'STT',
        },
        {
          key: 'id',
          value: 'Mã ticket',
        },
        {
          key: 'name',
          value: 'Họ và tên',
        },
        {
          key: 'phone',
          value: 'Số điện thoại',
        },
        {
          key: 'email',
          value: 'Email',
        },
        {
          key: 'birthday',
          value: 'Ngày sinh',
        },
        {
          key: 'center_name',
          value: 'Trung tâm học',
        },
        {
          key: 'branch_name',
          value: 'Chi nhánh học',
        },
        {
          key: 'course_name',
          value: 'Khóa học',
        },
        {
          key: 'classroom_name',
          value: 'Lớp học',
        },
        {
          key: 'status',
          value: 'Trạng thái ticket',
        },
        { // nghi lien tiep
          key: 'lesson_leave',
          value: 'Các buổi nghỉ',
        },
        { //diem thap
          key: 'exam_type',
          value: 'Buổi kiếm tra',
        },
        {
          key: 'exam_total_score',
          value: 'Kết quả',
        },
        { // feedback thấp
          key: 'feedback_star',
          value: 'Số sao',
        },
        {
          key: 'feedback_comment',
          value: 'Nội dung đánh giá',
        },
        {
          key: 'ticket_reason',
          value: 'Lý do',
        },
        {
          key: 'ticket_reason',
          value: 'Lý do feedback',
        },
        {
          key: 'person_in_charge_id',
          value: 'Mã nhân sự phụ trách',
        },
        {
          key: 'person_in_charge',
          value: 'Người phụ trách',
        },
        {
          key: 'ticket_reason',
          value: 'Lý do nghỉ',
        },
        {
          key: 'created_at',
          value: 'Thời gian tạo',
        },
        {
          key: 'change_success_status_at',
          value: 'Thời gian hoàn thành',
        },
        {
          key: 'time_call_first',
          value: 'Thời gian cuộc gọi lần đầu',
        },
        {
          key: 'message_call_first',
          value: 'Nội dung cuộc gọi đầu tiên',
        },
        {
          key: 'message_call_last',
          value: 'Nội dung cuộc gọi cuối ',
        },
      ]
      this.$store.dispatch(EXPORT_EXCEL_TICKET, this.query).then((data) => {
        if (this.query.category == 1) { // nghi hoc 2 buoi
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Buổi kiếm tra' && obj.value != 'Kết quả' && obj.value != 'Số sao' &&
                obj.value != 'Nội dung đánh giá' && obj.value != 'Lý do' && obj.value != 'Lý do feedback')
          });
        } else if (this.query.category == 2) { // diem kiem tra thap
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Các buổi nghỉ' && obj.value != 'Số sao' &&
                obj.value != 'Nội dung đánh giá' && obj.value != 'Lý do nghỉ' && obj.value != 'Lý do feedback')
          });
        } else if (this.query.category == 6) { // feedback thấp
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Các buổi nghỉ' && obj.value != 'Buổi kiếm tra' && obj.value != 'Kết quả' &&
                obj.value != 'Lý do' && obj.value != 'Lý do nghỉ')
          });
        } else if (this.query.category == 10) { // BTVN ko tot
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
          return (obj.value != 'Các buổi nghỉ' && obj.value != 'Buổi kiếm tra' && obj.value != 'Kết quả' &&
              obj.value != 'Số sao' && obj.value != 'Nội dung đánh giá' &&
              obj.value != 'Lý do feedback' && obj.value != 'Lý do nghỉ')
          });
        } else {
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Lý do feedback' && obj.value != 'Lý do nghỉ')
          });
        }
        exportExcel(HEADER_ROW_EXPORT_TICKETS_CSHV, data.data, "Danh sách ticket.xlsx", true)
        this.noticeMessage('success', 'Thành công', data.message);
      }).catch((err) => this.noticeMessage('error', 'Thất bại', err?.data.message))
        .finally(() => this.is_export = false);
    },
    exportExcelV2() {
      this.is_export = true;
      let HEADER_ROW_EXPORT_TICKETS_CSHV = [
        {
          key: 'stt',
          value: 'STT',
        },
        {
          key: 'ticket_id',
          value: 'Mã ticket',
        },
        {
          key: 'name',
          value: 'Họ và tên',
        },
        {
          key: 'phone',
          value: 'Số điện thoại',
        },
        {
          key: 'email',
          value: 'Email',
        },
        {
          key: 'birthday',
          value: 'Ngày sinh',
        },
        {
          key: 'center_name',
          value: 'Trung tâm học',
        },
        {
          key: 'branch_name',
          value: 'Chi nhánh học',
        },
        {
          key: 'course_name',
          value: 'Khóa học',
        },
        {
          key: 'classroom_name',
          value: 'Lớp học',
        },
        {
          key: 'status',
          value: 'Trạng thái ticket',
        },
        { // nghi lien tiep
          key: 'lesson_leave',
          value: 'Các buổi nghỉ',
        },
        { //diem thap
          key: 'exam_type',
          value: 'Buổi kiếm tra',
        },
        {
          key: 'exam_total_score',
          value: 'Kết quả',
        },
        { // feedback thấp
          key: 'feedback_star',
          value: 'Số sao',
        },
        {
          key: 'feedback_comment',
          value: 'Nội dung đánh giá',
        },
        {
          key: 'ticket_reason',
          value: 'Lý do',
        },
        {
          key: 'ticket_reason',
          value: 'Lý do feedback',
        },
        {
          key: 'ticket_reason',
          value: 'Lý do nghỉ',
        },
        {
          key: 'created_at',
          value: 'Thời gian tạo',
        },
      ]
      this.$store.dispatch(EXPORT_EXCEL_TICKET_V2, this.query).then((data) => {
        if (this.query.category == 1) { // nghi hoc 2 buoi
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Buổi kiếm tra' && obj.value != 'Kết quả' && obj.value != 'Số sao' &&
                obj.value != 'Nội dung đánh giá' && obj.value != 'Lý do' && obj.value != 'Lý do feedback')
          });
        } else if (this.query.category == 2) { // diem kiem tra thap
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Các buổi nghỉ' && obj.value != 'Số sao' &&
                obj.value != 'Nội dung đánh giá' && obj.value != 'Lý do nghỉ' && obj.value != 'Lý do feedback')
          });
        } else if (this.query.category == 6) { // feedback thấp
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Các buổi nghỉ' && obj.value != 'Buổi kiếm tra' && obj.value != 'Kết quả' &&
                obj.value != 'Lý do' && obj.value != 'Lý do nghỉ')
          });
        } else if (this.query.category == 10) { // BTVN ko tot
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Các buổi nghỉ' && obj.value != 'Buổi kiếm tra' && obj.value != 'Kết quả' &&
                obj.value != 'Số sao' && obj.value != 'Nội dung đánh giá' &&
                obj.value != 'Lý do feedback' && obj.value != 'Lý do nghỉ')
          });
        } else {
          HEADER_ROW_EXPORT_TICKETS_CSHV = HEADER_ROW_EXPORT_TICKETS_CSHV.filter(function( obj ) {
            return (obj.value != 'Lý do feedback' && obj.value != 'Lý do nghỉ')
          });
        }
        exportExcel(HEADER_ROW_EXPORT_TICKETS_CSHV, data.data, "Danh sách ticket.xlsx", true)
        this.noticeMessage('success', 'Thành công', data.message);
      }).catch((err) => this.noticeMessage('error', 'Thất bại', err?.data.message))
          .finally(() => this.is_export = false);
    },
    closeSurveyExportDialog() {
      this.showSurveyExportDialog = false;
      this.surveyExportTypes = [];
    },
    async handleSurveyExport() {
      if (!this.surveyExportTypes.length) {
        return;
      }

      this.is_export_survey = true;

      try {
        for (let i = 0; i < this.surveyExportTypes.length; i++) {
          if (i > 0) {
            await new Promise(resolve => setTimeout(resolve, 1500));
          }
          const type = this.surveyExportTypes[i];
          if (type === 'satisfaction') {
            await this.exportSatisfactionSurvey(false);
          } else if (type === 'brand') {
            await this.exportBrandSurvey(false);
          } else if (type === 'new') {
              await this.exportNewCustomerPoint(false);
          }
        }
        this.closeSurveyExportDialog();
      } catch (err) {
        return;
      } finally {
        this.is_export_survey = false;
      }
    },
    exportSatisfactionSurvey(shouldCloseDialog = true) {
      let HEADER_ROW_EXPORT_SURVEY = [
        { key: 'stt', value: 'STT' },
        { key: 'type', value: 'Loại khảo sát' },
        { key: 'user_name', value: 'Họ tên học viên' },
        { key: 'user_phone', value: 'Số điện thoại' },
        { key: 'classroom_name', value: 'Lớp học' },
        { key: 'teacher_name', value: 'Giảng viên' },
        { key: 'person_in_charge_id', value: 'Mã QLHV' },
        { key: 'person_in_charge_name', value: 'QLHV phụ trách' },
        { key: 'referrer_id', value: 'Mã giới thiệu' },
        { key: 'referrer_name', value: 'Tên người giới thiệu' },
        { key: 'center_name', value: 'Trung tâm' },
        { key: 'branch_name', value: 'Chi nhánh học' },
        { key: 'marks', value: 'Số điểm đánh giá' },
        { key: 'category', value: 'Phân loại lí do chưa hài lòng' },
        { key: 'comments', value: 'Nội dung đánh giá' },
        { key: 'created_at', value: 'Thời gian đánh giá' },
      ]
      return this.$store.dispatch(EXPORT_EXCEL_SURVEY, this.query).then((data) => {
        exportExcel(HEADER_ROW_EXPORT_SURVEY, data.data, "Export_Khao_sat_hai_long.xlsx", true)
        this.noticeMessage('success', 'Thành công', data.message);
        if (shouldCloseDialog) {
          this.closeSurveyExportDialog();
        }
      }).catch((err) => {
        this.noticeMessage('error', 'Thất bại', err?.data?.message);
        throw err;
      })
    },
    exportBrandSurvey(shouldCloseDialog = true) {
      const BRAND_SURVEY_COLUMNS = [
        { key: 'ma_hoc_vien', subHeader: 'Mã học viên' },
        { key: 'ten_hoc_vien', subHeader: 'Tên học viên' },
        { key: 'so_dien_thoai', subHeader: 'Số điện thoại' },
        { key: 'chi_nhanh', subHeader: 'Chi nhánh' },
        { key: 'address', subHeader: 'Địa chỉ' },
        { key: 'thoi_gian_nop', subHeader: 'Thời gian nộp' },
        { key: 'loai_khao_sat', subHeader: 'Loại khảo sát' },
        { key: 'cau_1', subHeader: 'Cau_1_Muc_do_am_hieu_IELTS' },
        { key: 'cau_2_0', subHeader: 'Cau_2_Chua_tung_biet' },
        { key: 'cau_2_1', subHeader: 'Cau_2_Facebook' },
        { key: 'cau_2_2', subHeader: 'Cau_2_TikTok' },
        { key: 'cau_2_3', subHeader: 'Cau_2_Google_Search' },
        { key: 'cau_2_4', subHeader: 'Cau_2_Ban_be_nguoi_than' },
        { key: 'cau_2_5', subHeader: 'Cau_2_Hoc_vien_cu_Phu_huynh' },
        { key: 'cau_2_6', subHeader: 'Cau_2_Truong_hoc_Workshop' },
        { key: 'cau_2_10', subHeader: 'Cau_2_Vu_Dai_Tri_Tue' },
        { key: 'cau_2_7', subHeader: 'Cau_2_Di_ngang_qua_co_so' },
        { key: 'cau_2_8', subHeader: 'Cau_2_Quang_cao_chung_cu_quang_cafe' },
        { key: 'cau_2_9', subHeader: 'Cau_2_Da_tung_den_co_so_chu_dong_tim_hieu' },
        { key: 'cau_3', subHeader: 'Cau_3_Diem_NPS_San_sang_gioi_thieu' },
      ]

      const columns = [
        { width: 35 },
        { width: 22 },
        { width: 17 },
        { width: 21 },
        { width: 20 },
        { width: 17 },
        { width: 45 },
        { width: 24 },
        { width: 18 },
        { width: 16 },
        { width: 23 },
        { width: 27 },
        { width: 31 },
        { width: 29 },
        { width: 24 },
        { width: 28 },
        { width: 39 },
        { width: 45 },
        { width: 38 },
      ]

      const totalCols = BRAND_SURVEY_COLUMNS.length
      const question2Cols = BRAND_SURVEY_COLUMNS.filter(col => col.key.indexOf('cau_2_') === 0).length

      const getExcelColumnName = (index) => {
        let n = index
        let name = ''

        while (n > 0) {
          const remainder = (n - 1) % 26
          name = String.fromCharCode(65 + remainder) + name
          n = Math.floor((n - 1) / 26)
        }

        return name
      }

      const createTitleCell = () => ({
        value: 'BÁO CÁO DỮ LIỆU KHẢO SÁT THƯƠNG HIỆU (IELTS MENTOR & CLASSUP)',
        fontFamily: 'Segoe UI',
        fontSize: 16,
        fontWeight: 'bold',
        color: '#1F4E79',
        height: 30,
      })

      const createGroupCell = (value, extra = {}) => ({
        value,
        fontFamily: 'Segoe UI',
        fontSize: 11,
        fontWeight: 'bold',
        color: '#FFFFFF',
        backgroundColor: '#1F4E79',
        align: 'center',
        alignVertical: 'center',
        wrap: true,
        borderColor: '#D9D9D9',
        leftBorderStyle: 'thin',
        leftBorderColor: '#D9D9D9',
        rightBorderStyle: 'thin',
        rightBorderColor: '#D9D9D9',
        topBorderStyle: 'thin',
        topBorderColor: '#D9D9D9',
        bottomBorderStyle: 'medium',
        bottomBorderColor: '#1F4E79',
        height: 27.95,
        ...extra,
      })

      const createHeaderCell = (value, extra = {}) => ({
        value,
        fontFamily: 'Segoe UI',
        fontSize: 10,
        fontWeight: 'bold',
        color: '#1F4E79',
        backgroundColor: '#D9E1F2',
        align: 'center',
        alignVertical: 'center',
        wrap: true,
        borderColor: '#D9D9D9',
        borderStyle: 'thin',
        height: 24,
        ...extra,
      })

      const createDataCell = (value, rowIndex, extra = {}) => ({
        value,
        fontFamily: 'Segoe UI',
        fontSize: 11,
        color: '#000000',
        backgroundColor: rowIndex % 2 === 0 ? '#F2F4F8' : '#FFFFFF',
        borderColor: '#D9D9D9',
        borderStyle: 'thin',
        alignVertical: 'center',
        ...extra,
      })

      const createTotalBlankCell = () => ({
        value: null,
        fontFamily: 'Segoe UI',
        fontSize: 11,
        borderTopStyle: 'thin',
        borderTopColor: '#D9D9D9',
        borderBottomStyle: 'double',
        borderBottomColor: '#1F4E79',
        height: 24,
      })

      const createTotalFormulaCell = (formula, format) => ({
        type: 'Formula',
        value: formula,
        fontFamily: 'Segoe UI',
        fontSize: 11,
        fontWeight: 'bold',
        color: '#000000',
        align: 'center',
        alignVertical: 'center',
        borderTopStyle: 'thin',
        borderTopColor: '#D9D9D9',
        borderBottomStyle: 'double',
        borderBottomColor: '#1F4E79',
        format,
        height: 24,
      })

      const createTotalAverageCell = (formula) => createTotalFormulaCell(formula, '0.0')

      const titleRow = [createTitleCell()]
      const emptyRow = Array(totalCols).fill(null)

      const groupRow = [
        createGroupCell('THÔNG TIN NỀN HỌC VIÊN', { span: 6 }),
        null,
        null,
        null,
        null,
        null,
        createGroupCell('CÂU 1: MỨC ĐỘ AM HIỂU IELTS (SINGLE-CHOICE)'),
        createGroupCell('CÂU 2: KÊNH TIẾP CẬN THƯƠNG HIỆU (MULTIPLE-CHOICE - MA TRẬN PHÂN NHỊ PHÂN 0/1)', { span: question2Cols }),
        ...Array(question2Cols - 1).fill(null),
        createGroupCell('CÂU 3: ĐỘ SẴN SÀNG GIỚI THIỆU (THANG ĐIỂM NPS 0-10)'),
      ]

      const subHeaderRow = BRAND_SURVEY_COLUMNS.map((col) => createHeaderCell(col.subHeader))

      return this.$store.dispatch(EXPORT_BRAND_SURVEY, this.query).then((data) => {
        const surveyRows = (Array.isArray(data.data) ? data.data : []).filter((item) => {
          return !Object.values(item || {}).some((value) => {
            return typeof value === 'string' && value.trim() === 'Tổng cộng (Lượt chọn)'
          })
        })

        const dataRows = surveyRows.map((item, rowIndex) => {
          return BRAND_SURVEY_COLUMNS.map((col) => {
            if (col.key.indexOf('cau_2_') === 0 || col.key === 'cau_3') {
              const numericValue = Number(item[col.key])
              return createDataCell(Number.isFinite(numericValue) ? numericValue : 0, rowIndex, {
                type: Number,
                align: 'center',
              })
            }

            const textValue = item[col.key] != null ? item[col.key] : ''
            const textAlign = col.key === 'ma_hoc_vien' || col.key === 'so_dien_thoai' || col.key === 'thoi_gian_nop' || col.key === 'loai_khao_sat'
              ? 'center'
              : (col.key === 'ten_hoc_vien' || col.key === 'chi_nhanh' || col.key === 'cau_1' ? 'left' : 'center')

            return createDataCell(textValue, rowIndex, {
              align: textAlign,
            })
          })
        })

        const firstDataRowNumber = 5
        const lastDataRowNumber = firstDataRowNumber + surveyRows.length - 1

        const totalRow = [
          {
            value: 'Tổng cộng (Lượt chọn / Điểm TB)',
            fontFamily: 'Segoe UI',
            fontSize: 11,
            fontWeight: 'bold',
            color: '#000000',
            align: 'left',
            alignVertical: 'center',
            borderTopStyle: 'thin',
            borderTopColor: '#D9D9D9',
            borderBottomStyle: 'double',
            borderBottomColor: '#1F4E79',
            height: 24,
          },
          ...Array.from({ length: 6 }, () => createTotalBlankCell()),
          ...BRAND_SURVEY_COLUMNS
            .filter(col => col.key.indexOf('cau_2_') === 0)
            .map((col, index) => {
              const columnName = getExcelColumnName(8 + index)
              const formula = surveyRows.length
                ? `SUM(${columnName}${firstDataRowNumber}:${columnName}${lastDataRowNumber})`
                : '0'
              return createTotalFormulaCell(formula, '#,##0')
            }),
          createTotalAverageCell(surveyRows.length ? `AVERAGE(S${firstDataRowNumber}:S${lastDataRowNumber})` : '0'),
        ]

        const allRows = [titleRow, emptyRow, groupRow, subHeaderRow, ...dataRows, totalRow]

        writeXlsxFile(allRows, {
          fileName: 'Export_Khao_sat_thuong_hieu.xlsx',
          columns,
          fontFamily: 'Segoe UI',
          fontSize: 11,
        })

        this.noticeMessage('success', 'Thành công', data.message ?? 'Export khảo sát thương hiệu thành công !')
        if (shouldCloseDialog) {
          this.closeSurveyExportDialog()
        }
      }).catch((err) => {
          this.noticeMessage('error', 'Thất bại', err?.data?.message)
          throw err
      })
    },
      exportNewCustomerPoint(shouldCloseDialog = true) {
          const HEADER_ROW_EXPORT_NEW_CUSTOMER_SURVEY = [
              {key: 'stt', value: 'STT'},
              {key: 'contract_id', value: 'Mã hợp đồng'},
              {key: 'customer_code', value: 'Mã học viên'},
              {key: 'customer_name', value: 'Tên học viên'},
              {key: 'customer_phone', value: 'Số điện thoại'},
              {key: 'tvv_id', value: 'Mã TVV'},
              {key: 'tvv_branch_id', value: 'Mã văn phòng'},
              {key: 'tvv_branch_name', value: 'Tên văn phòng'},
              {key: 'center_name', value: 'Trung tâm'},
              {key: 'branch_name', value: 'Chi nhánh'},
              {key: 'rating', value: 'Đánh giá'},
              {key: 'survey_type', value: 'Loại khảo sát'},
              {key: 'reasons', value: 'Lý do'},
              {key: 'message', value: 'Nội dung'},
              {key: 'created_at', value: 'Thời gian khảo sát'},
          ]

          return this.$store.dispatch(EXPORT_CONTRACT_SURVEY, this.query).then((data) => {
              const rows = Array.isArray(data.data) ? data.data : (data.data?.data || [])
              exportExcel(HEADER_ROW_EXPORT_NEW_CUSTOMER_SURVEY, rows, 'Export_Khao_sat_diem_cham_khach_hang_moi.xlsx', true)
              this.noticeMessage('success', 'Thành công', data.message)
              if (shouldCloseDialog) {
                  this.closeSurveyExportDialog()
              }
          }).catch((err) => {
        this.noticeMessage('error', 'Thất bại', err?.data?.message)
        throw err
      })
    },

    createTicket() {
      this.dialogCreateTicket = true;
    },
    emitUpdateFile(e) {
      this.fileList = e;
    },
    getSource() {
      this.sources = [];
      this.$store.dispatch(GET_SOURCE).then((data) => {
        for (const key in data.data) {
          this.sources.push({
            id: key,
            name: data.data[key]
          })
        }
      })
    },
    getDepartments() {
      this.$store.dispatch(GET_DEPARTMENT, {
        all: true,
        status: 1
      }).then((data) => {
        this.departments = data.data;
      })
    },
    getObjectFeedback() {
      this.objectFeedback = [];
      this.$store.dispatch(GET_OBJECT_FEEDBACK).then((data) => {
        for (const key in data.data) {
          this.objectFeedback.push({
            id: key,
            name: data.data[key]
          })
        }
      })
    },
    changeCategoryName(category_chamsoc)
    {
      let text = '';
      switch (category_chamsoc) {
        case '1':
          text = 'Nghỉ học';
          break;
        case '2':
          text = 'Điểm kiểm tra thấp';
          break;
        case '6':
          text = 'Feedback thấp';
          break;
        case '10':
          text = 'Kết quả BTVN không tốt';
          break;
        case '11':
          text = 'Không làm BTVN';
          break;
        case '13':
          text = 'Nhắc nhở bảo hành';
          break;
        case '14':
          text = 'Nghỉ 1 buổi không phép';
          break;
        case '15':
          text = 'Nghỉ buổi khai giảng';
          break;
        case '24':
          text = 'Chăm sóc học viên thi giữa khóa';
          break;
        case '26':
          text = 'Học video buổi nghỉ';
          break;
      }
      return text;
    },
    handleSelectAll(val) {
      if (val) {
        this.selectedItems = this.tickets.data
          .filter(item => item.status != 3 && item.status != 0)
          .map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    onAssignConfirm(data)
    {
      this.$store.dispatch(ASSIGNEES_TICKET, {assignee_id: data.assignee_id, ticket_ids: this.selectedItems}).then((res) => {
        this.assignDialogVisible = false;
        this.$message.success('Điều phối công việc thành công');
        this.selectedItems = [];
        this.getList();
      })
    },
    openAssignDialog()
    {
      this.assignDialogVisible = true;
    },
    getDataQlhv()
    {
      this.$store.dispatch(GET_USER_QLHV, {department_id: 31}).then((data) => {
        this.qlhvAssignees = data.data;
      })
    }
  }
}
</script>

<style scoped>
.bg-violet {
  background: #5E00B6;
}
</style>
